export const SOKANU_DIR = 'SokanuProBono';
export const VIRTUAL_ASSISTANT_DIR = 'VirtualAssistant';
export const ICF_DIR = 'IcfProBono';
export const SOAR_DIR = 'SoarDirectory';

export const SOKANU_HOST = 'careerexplorer.soar.com';
export const VIRTUAL_ASSISTANT_HOST = 'va.soar.com';
export const ICF_HOST = 'icfcoachesforgood.org';
export const SOAR_HOST = '';
